import React, { useEffect, useState } from 'react';
import UsuarioForm from './UsuarioForm';
//import $ from 'jquery';
import api from '../../../services/api';

export default function Usuario() {
	const [usuarios, setUsuarios] = useState([]);
	const [loading, setLoading] = useState(true);
	const [modalVisibleNovo, setModalVisibleNovo] = useState(false);
	//const [modalVisibleEdit, setModalVisibleEdit] = useState(false);
	//const [usuario, setUsuario] = useState();


	const novoUsuarioModal = React.createRef();

	useEffect(() => {
		buscaUsuarios();
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	async function buscaUsuarios() {
		//let self = this;
		////console.log('iniciando');
		try {
			const response = await api.get('/admin/usuario/json');
		const { data, status } = response;
		////console.log('pesquisado');
		////console.log(status);
		////console.log(data);
		if (status === 200 && data instanceof Array) {
			////console.log(data);
			setUsuarios(data);
			setLoading(false);
		}
			
		} catch (error) {
			alert('error: '+error)
			if (error.response.status === 401){
				window.location.reload(false);
				
			}
		}
		
	}

	//async function removerUsuario(usuario) {
		/*if (!window.confirm('Deseja realmente apagar esse registro ?')) {
			return;
		}

		//let self = this;

		try {
			const response = api.delete('/admin/usuario/' + usuario.id);
			const { data, status } = response;
			if (status === 200 && data === true) {
				buscaUsuarios();
				return;
			} else {
				//////console.log(response.status);
				//////console.log(response.data);
			}
		} catch (error) {
			alert('Error: ' + error);
		}

		/* if (! confirm("Deseja realmente apagar esse registro ?")) {
            return;
        }*/
		/*
        let self = this;
        $.ajax({
            url: '/admin/usuario/' + usuario.id,
            method: 'DELETE'
        })
        .then(function(data, status) {
            if (status == "success" && data === true) {
                self.buscaUsuarios();
                return;
            }
        })
        */
	//}

	function updateUsuarios(usuario) {
		const p = [...usuarios];
		let index = -1;

		for (let i = 0; i < p.length; i++) {
			if (p[i].id === usuario.id) {
				index = i;
			}
		}

		if (index !== -1) {
			//u.splice(index,1);
			////console.log(p[index]);
			p[index] = usuario;
			////console.log(p[index]);
		} else {
			p.push(usuario);
		}

		setUsuarios([...p]);
	}

	return (
		<div style={{paddingTop:30,paddingLeft:15}} className='Usuario row'>
			<div className='col-md-12 header-page p-3'>
				<h2 className='title'>
					Usuários
					<div className='d-inline-block ml-4'>
						<button
							className='btn btn-sm btn-success'
							data-toggle='modal'
							data-target='#novoUsuarioModal'
							onClick={() => {
								novoUsuarioModal.current.resetForm();
								setModalVisibleNovo(true);
							}}>
							Novo Usuário
						</button>
					</div>
				</h2>
				<UsuarioForm
					ref={novoUsuarioModal}
					elementId='novoUsuarioModal'
					callback={updateUsuarios}
					modalVisible={modalVisibleNovo}
					setModalVisible={setModalVisibleNovo}
				/>
			</div>
			<div className='col-md-12'>
				<div className='card border-0 mt-4'>
					<div className='card-body'>
						<div className='row'>
							<div className='col-md-12 mb-2'>
								<div className='float-right'></div>
							</div>
							<div className='col-md-12'>
								<table className='table'>
									<thead>
										<tr>
											<th>Usuário</th>
											<th>Situação</th>
											<th>Permissão</th>
											<th></th>
										</tr>
									</thead>
									{loading ? (
										<tbody>
											<tr>
												<td>{<div className='Skeleton'></div>}</td>
												<td>
													{' '}
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
											</tr>
											<tr>
												<td>{<div className='Skeleton'></div>}</td>
												<td>
													{' '}
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
											</tr>
											<tr>
												<td>{<div className='Skeleton'></div>}</td>
												<td>
													{' '}
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
												<td>
													<div className='Skeleton'></div>
												</td>
											</tr>
										</tbody>
									) : (
										<tbody>
											{usuarios.map((usuario) => (
												<UsuarioContainer
													usuario={usuario}
													updateUsuarios={updateUsuarios}
												/>
											))}
										</tbody>
									)}
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}

function UsuarioContainer(props) {
	const { usuario, updateUsuarios } = props;

	const [modalVisibleEdit, setModalVisibleEdit] = useState(false);

	//const [loading, setLoading] = useState(false);
	//console.log(usuario);

	return (
		<tr key={usuario.id}>
			<UsuarioForm
				elementId={'editarUsuario' + usuario?.id + 'Modal'}
				item={usuario}
				callback={updateUsuarios}
				modalVisible={modalVisibleEdit}
				setModalVisible={setModalVisibleEdit}
			/>
			<td>{usuario.login}</td>
			<td>{usuario.status === 1 ? 'Ativa' : 'Desativado'}</td>
			<td>
				{usuario.permissao === 1 || usuario.permissao === '1'
					? 'Consultor'
					: 'Administrador'}
			</td>
			<td>
				<div className='float-right'>
					<button
						onClick={(e) => {
							e.preventDefault();
							//setUsuario(usuario);
							setModalVisibleEdit(true);
						}}
						className='btn btn-sm btn-primary mr-1'
						data-toggle='modal'
						data-target={'#editarUsuario' + usuario.id + 'Modal'}>
						Editar
					</button>
				</div>
			</td>
		</tr>
	);
}
